import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { SwitchComponent } from '../../../components/switch/switch.component';
import { downloadSizes } from '../../../consts';
import { convertGalleryDownloadSize } from '../../../lib/convert-gallery-download-size';
import { GalleryService } from '../../../services/gallery.service';
import { AccessItemBodyComponent } from '../access-item-body/access-item-body.component';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';
import { GallerySettingsCustomizeHeaderComponent } from '../gallery-settings-customize-header/gallery-settings-customize-header.component';
import { GallerySettingsGroupComponent } from '../gallery-settings-group/gallery-settings-group.component';

@Component({
  selector: 'app-download-sizes-setting-customize',
  imports: [
    GallerySettingsCustomizeHeaderComponent,
    GallerySettingsGroupComponent,
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemBodyComponent,
    AccessItemCtaComponent,
    SwitchComponent,
    FormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './download-sizes-setting-customize.component.html',
  styleUrls: ['./download-sizes-setting-customize.component.scss'],
})
export class DownloadSizesSettingCustomizeComponent {
  galleryService = inject(GalleryService);
  gallery = input.required<GalleryDto>();
  back = output<void>();

  small = model<boolean>();
  medium = model<boolean>();
  large = model<boolean>();
  original = model<boolean>();

  disableLast = computed(() => {
    const gallery = this.gallery();
    if (!gallery) return true;
    const enabledSizes = convertGalleryDownloadSize(gallery.download_media_size);
    return Object.values(enabledSizes).filter(Boolean).length === 1;
  });

  constructor() {
    effect(() => {
      const gallery = this.gallery();
      if (!gallery) return;
      const enabledSizes = convertGalleryDownloadSize(gallery.download_media_size);
      this.small.set(enabledSizes.small);
      this.medium.set(enabledSizes.medium);
      this.large.set(enabledSizes.large);
      this.original.set(enabledSizes.original);
    });
  }

  updateSizes() {
    const enabledDownloadSizes = {
      small: this.small(),
      medium: this.medium(),
      large: this.large(),
      original: this.original(),
    };

    const downloadSizesString = downloadSizes.map(s => (enabledDownloadSizes[s.name] ? '1' : '0')).join('');
    let downloadMediaSize = parseInt(downloadSizesString, 2);
    const maxSize = Math.pow(2, downloadSizes.filter(d => d.name !== 'reserved').length) - 1;
    if (downloadMediaSize === maxSize) downloadMediaSize = 999999;
    this.galleryService.updateGallery(this.gallery().id, { download_media_size: downloadMediaSize });
  }
}
